import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../../services/utilityFunctions';
import RemoveCartItemButton from './components/RemoveCartItemButton';
import CartItemImage from './components/CartItemImage';
import ProductVariationsProp from '../propTypes/productVariationsProp';
import translate from '../../../commonComponents/translate';
import ShopProductVariationQuantity from '../shopItems/ShopProductVariationQuantity';
import CartItemName from './components/CartItemName';
import CartStateProp from '../propTypes/cartStateProp';
import CartProductInfo from './components/CartProductInfo';
import CartPriceItem from './components/CartPriceItem';
import CartSubscriptionSelector from './components/CartSubscriptionSelector';

function ProductCheckoutItem(props) {
  const {
    t,
    product,
    onRemoveProduct,
    cartState,
    onUpdateCartAmount,
    productsAvailability,
    getStockManagementMsg,
    onUpdateProductFrequency,
  } = props;
  const {
    id: productId,
    amount,
    priceWithoutVAT,
    symbol,
    tax,
    priceWithVAT,
  } = product || {};

  const handleQtyChange = useCallback(
    type => {
      const unityToChange = type === 'plus' ? 1 : -1;
      if (amount && amount + unityToChange >= 1) {
        onUpdateCartAmount(
          productId,
          parseInt((amount || 0) + unityToChange, 10),
        );
      }
    },
    [cartState?.products, onUpdateCartAmount],
  );

  return (
    <li className="product-checkout-item">
      <RemoveCartItemButton
        product={product}
        onRemoveProduct={onRemoveProduct}
      />
      <CartItemImage product={product} />
      <div className="product-info">
        <CartItemName product={product} />
        <CartSubscriptionSelector
          product={product}
          onUpdateProductFrequency={onUpdateProductFrequency}
        />
        <div className="change-product-quantity-wrapper">
          <ShopProductVariationQuantity
            variation={product}
            currentVariation={product}
            handleChange={handleQtyChange}
            isTouched
            hideMinusButtonThreshold={1}
          />
        </div>
        <CartProductInfo
          product={product}
          productsAvailability={productsAvailability}
          getStockManagementMsg={getStockManagementMsg}
        />
      </div>
      <div className="cart-prices-wrapper">
        <CartPriceItem
          title={t('shop.product.subtotal')}
          subtitle={t('shop.product.subtotal.withoutTax')}
          value={formatPrice(priceWithoutVAT, symbol)}
        />
        <CartPriceItem
          title={t('shop.product.subtotal')}
          subtitle={`${t('shop.product.subtotal.withTax')}, ${tax}%`}
          value={formatPrice(priceWithVAT, symbol)}
        />
      </div>
    </li>
  );
}

ProductCheckoutItem.propTypes = {
  t: PropTypes.func.isRequired,
  onRemoveProduct: PropTypes.func.isRequired,
  onUpdateCartAmount: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  cartState: PropTypes.shape(CartStateProp.propType).isRequired,
  productsAvailability: PropTypes.arrayOf(PropTypes.string),
  getStockManagementMsg: PropTypes.func.isRequired,
  onUpdateProductFrequency: PropTypes.func.isRequired,
};

ProductCheckoutItem.defaultProps = {
  productsAvailability: [],
};

export default translate(ProductCheckoutItem);
